<template>

  <div class="feedItem d-flex flex-row justify-content-between">

    <div class="panel w-100 singleCard lightest d-flex flex-column" :class="{'bg-color-6': unreadNotificationsNr > 0, 'bg-dark': unreadNotificationsNr == 0}">
      <div class="d-flex flex-row h-50">
        <div class="w-50 fs-uberhuge font-weight-600">{{unreadNotificationsNr}}</div>
        <div class="w-50 d-flex align-items-center justify-content-end mt-3">

        </div>
      </div>
      <div class="h-50 d-flex flex-column justify-content-end">
        <div class="font-weight-600">Alerts to read</div>
      </div>
    </div>

    <div class="panel w-100 singleCard bg-dark lightest" v-if="cardInfo.nrPickups > 0">
      <div class="text-uppercase fs-larger h-50">Pickups</div>
      <div class="h-50 d-flex flex-column justify-content-end">
        <div class="font-weight-600">{{cardInfo.nrPickups}} active<br> pickups now</div>
      </div>
    </div>

    <div class="panel w-100 singleCard bg-dark lightest">
      <div class="text-uppercase fs-large h-50">Bookings</div>
      <div class="h-50 d-flex flex-column justify-content-end">
        <div class="font-weight-600">{{cardInfo.nrBookings}} new bookings</div>
      </div>
    </div>

    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  created: function(){

    this.loadEvents(
      //this month
      //moment().startOf('month').format('YYYY-MM-DD'),
      //moment().endOf('month').format('YYYY-MM-DD')

      //today
      moment(new Date).format('YYYY-MM-DD'),
      moment(new Date).add(1, 'days').format('YYYY-MM-DD')
    );


  },
  data: function() {
    return{
      cardInfo:{
        nrPickups:0,
        nrBookings:0
      }
    }
  },
  computed:{
    ...mapGetters([
        'getNotifications',
        'getUnreadNotificationsNr',
        'account'
    ]),
    notifications: function() {
        return this.getNotifications;
    },
    unreadNotificationsNr: function() {
      return this.getNotifications.filter(function(notification){
          return !notification.markedAsRead
      }).length;
    }
  },
  methods:{
    ...mapActions([
      'fetchUserDetails'
    ]),
    loadEvents: function(start, end) {

      try {
        //this.fetchUserDetails().then(() => {
            axios.get('api/calendar/GetEvents', { params: {
                supplierId: this.account.supplierId, //hardcoded
                dateFrom: start,
                dateTo: end
            }}).then(response => {
                if (response && response.status === 200) {
                  if(response.data.events.length > 0){
                    this.countBookings(response.data.events);
                  }
                }
            });
        //});
      }
      catch (error) {
      }
    },
    countBookings: function(eventsArr){
      let totalBookings = 0;
      for (let singleEvent of eventsArr) {
        totalBookings += singleEvent.maximumLotation - singleEvent.quantityAvailable;
      }

      this.nrBookings = totalBookings;
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  // used on the weather temperature
  .fs-uberhuge{
    font-size: 2.5rem;
  }


  .panel{
    height: 118px !important;
    padding: 1rem;
  }

  .feed .feedItem{
    height: auto;
  }

  .singleCard{

    &:first-child{
      margin-left: 0;
    }

    flex-grow: 1;
    margin-left: 15px;
    margin-top: 0;
  }

</style>



// WEBPACK FOOTER //
// FeedcardMulti.vue?2b641990